import { DynamicObject } from './commonTypes';

export const timeConversion = (
  duration: number,
  minuteSecondFormatFlag?: boolean
) => {
  const num = duration;
  if (typeof num === 'number') {
    if (num < 60) {
      return num < 0 ? '0s' : `${num}s`;
    }
    const hours = num / 3600;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.floor(minutes);
    const rseconds =
      Math.floor((minutes - rminutes) * 60) === 0
        ? '00'
        : Math.floor((minutes - rminutes) * 60);
    // for Live tv card
    if (minuteSecondFormatFlag) {
      if (rhours > 0) {
        return `${rhours}h ${rminutes === 0 ? '00' : rminutes}m ${rseconds}s`;
      }
      return `${rminutes === 0 ? '00' : rminutes}m ${rseconds}s`;
    }

    if (rhours > 0 && rminutes > 0) {
      return `${rhours}h ${rminutes}m`;
    }
    if (rhours > 0) {
      return `${rhours}h`;
    }
    return `${rminutes}m`;
  }
  return '';
};

export const getTimeIn24HourFormat = (time: string) => {
  if (time) {
    const hours = new Date(time).getHours();
    const minutes = new Date(time).getMinutes();
    return `${hours === 0 ? '00' : hours}:${minutes === 0 ? '00' : minutes}`;
  }
  return null;
};

export const dateConversionObj = (date: string | Date) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const fullMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  if (date) {
    const airedTime =
      date.toString().split('T').length > 1
        ? getTimeIn24HourFormat(date as string)
        : null;
    date = new Date(date);
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const fullMonthString = fullMonthNames[date.getMonth()];
    const year = date.getFullYear();
    if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) {
      return {
        day: null,
        month: null,
        year: null,
        airedTime: null
      };
    }
    return {
      day,
      month,
      year,
      airedTime,
      fullMonthString
    };
  }
  return {
    day: null,
    month: null,
    year: null,
    airedTime: null
  };
};

export const getHoursInDays = (
  hours: number,
  plexTranslation?: DynamicObject
) => {
  const daysCount = Math.floor(hours / 24);
  if (plexTranslation && Object.keys(plexTranslation).length) {
    return `${daysCount} ${
      daysCount > 1 ? plexTranslation.Days : plexTranslation.Day
    }`;
  }
  return `${daysCount}`;
};

export const getDayPrefix = (day: number) => {
  let daySuffix = '';
  if (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        daySuffix = 'st';
        break;
      case 2:
      case 22:
        daySuffix = 'nd';
        break;
      case 3:
      case 23:
        daySuffix = 'rd';
        break;
      default:
        daySuffix = 'th';
        break;
    }
  }
  return daySuffix;
};
